import useScreenSize from "../../hooks/useScreenSize";
// import fi from "../../images/fi.png";

const FutureImg = () => {
  const screenSize = useScreenSize();

  return (
    <div
      className="top-img-comp"
      style={{ height: `${screenSize.height - 90}px` }}
    >
      <div className="top-img-div">
        {/* <img src={fi} alt="top-img" className="top-img location" /> */}
      </div>
      <div className="top-img-title">FUTURE INTITIATIVES</div>
    </div>
  );
};

export default FutureImg;
